var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("系统管理")]),_c('el-breadcrumb-item',{attrs:{"to":{path:'/batch'}}},[_vm._v("批次管理")]),_c('el-breadcrumb-item',[_vm._v("激活码管理")])],1),_c('div',{staticClass:"accountMain"},[_c('activationCodeTable',{ref:"childrene"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }